import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import SectionWithCarouselColumn, { IContentItem } from "@organic-return/foundation-react/src/components/Blades/SectionWithCarouselColumn"
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa"
import { WsrvImage } from "@organic-return/foundation-react/src/components/Media"
import { EWsrvTransform } from "@organic-return/foundation-react/src/lib"
import { useSiteContext } from "../common/SiteContext"

const OfficesCarousel = ({ module }) => {
    const data = useStaticQuery(graphql`
    query {
        allOffice {
          nodes {
            photos {
              url
            }
            address {              
              city
              state
              postal
              street1
              street2
              country
              county
            }
            phone
            email
            fullName
            description
          }
        }
    }
  `)

    const siteContext = useSiteContext()

    const offices = data.allOffice

    const sectionItems = offices?.nodes?.map((office, index): IContentItem => {

        return {
            label: office.fullName,
            linkedContent: (
                <WsrvImage
                    urlParams={{
                        originURL: office.photos![0]?.url,
                        preset: EWsrvTransform.limit,
                    }}
                    imgProps={{
                        className: "lg:min-h-[758px] h-full object-cover"
                    }}
                    lazy={false}
                />
            ),
            slideContent: (
                <div key={index} className="w-full flex flex-col justify-start">
                    <h2 className="text-ellipsis overflow-hidden">{office.fullName}</h2>
                    {office.description && <div className="pb-8" dangerouslySetInnerHTML={{ __html: office.description }}></div>}
                    {office.address && (<address className="flex flex-row justify-start items-center gap-5 pb-8">
                        <FaMapMarkerAlt />
                        <span>
                            {`${office.address.street1}${office.address.street2 && ` ${office.address.street2}`}`} <br />
                            {`${office.address.city}${office.address.state && `, ${office.address.state}`}${office.address.postal && `, ${office.address.postal}`}`}
                        </span>
                    </address>)}
                    {office.phone && <a className="inline-flex text-body-text-inverted flex-row justify-start items-center gap-5 pb-14 cursor-pointer">
                        <FaPhoneAlt />
                        <span>{office.phone}</span>
                    </a>}
                    {office.email && (
                        <a className="font-bold tracking-widest block w-max bg-accent py-4 px-10 text-white text-xs uppercase" href={`mailto:${office.email}`}>{`Email Our ${office.fullName}`}</a>
                    )}
                </div>
            )
        }
    }) ?? []

    if (!sectionItems || sectionItems.length == 0) {
        return <></>
    }

    return (
        <SectionWithCarouselColumn
            className="offices-carousel max-w-screen-2xl mx-auto"
            columnsContent={sectionItems}
            {...siteContext.globalOfficesCarouselProps}
        />
    )
}

export default OfficesCarousel